import React from "react";
import "./index.css";
import { Container } from "react-bootstrap";
import RecentBlog from "@/components/common-components/recent-blog/RecentBlog";
import BlogChip from "@/components/common-components/blog-chip/BlogChip";
import { Folder02Icon } from "@/utlility/icons";
import Image from "next/image";
import { formatDate } from "@/utlility/Functions";

const FullBlogSection = ({ blogDetails, recentBlogs }) => {

  const getEmbedLink = (url) => {
    if (!url) return "";

    try {
      const urlObj = new URL(url);
      const videoId = urlObj.searchParams.get("v");

      if (videoId) {
        return `https://www.youtube.com/embed/${videoId}`;
      }

      // If it's already an embed link, return as is
      if (url.includes("/embed/")) return url;

      return ""; // fallback
    } catch (err) {
      return "";
    }
  };

  return (
    <section className="full-blog">
      <Container>
        <div className="grid full-blog-page-cover">
            <article className="blog g-col-12 g-col-lg-12 g-col-xl-8">
              <div className="image">
                <Image
                  src={`${blogDetails?.blog_image}`}
                  alt={`${blogDetails?.blog_title}`}
                  title={`${blogDetails?.blog_title}`}
                  width={860}
                  height={1140}
                  priority={true}
                  fetchPriority="high"
                  sizes="(max-width: 768px) 100vw, 860px"
                />
              </div>
              <BlogChip name={blogDetails?.author} date={formatDate(blogDetails?.created_at, "MMMM DD, YYYY")} />
              <div className="categori-list d-flex flex-wrap align-items-center gap-2">
                <div className="categori-chip pe-2 d-flex flex-nowrap align-items-center gap-2">
                  <Folder02Icon
                    width={16}
                    height={16}
                    color="#BED643"
                    strokeWidth="2"
                  />
                </div>
                {blogDetails?.tags?.map((item, index) => (
                  <div key={index} className="categori-chip pe-2 d-flex flex-nowrap align-items-center gap-2">
                    <p className="text-capitalize">{item.name}</p>
                  </div>
                ))}
              </div>
              <div className="main-text-content mt-2">
                <h2 className="blog-title fw-semibold mb-3">
                  {blogDetails?.blog_title}
                </h2>
                <div className="html-content" dangerouslySetInnerHTML={{ __html: blogDetails?.blog_description }} />
                {blogDetails && blogDetails?.video_link && (

                  <div className="mt-5">
                    <iframe
                      width="100%"
                      height={450}
                      src={getEmbedLink(blogDetails.video_link)}
                      title="YouTube video player"
                      frameBorder={0}
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      // referrerPolicy="strict-origin-when-cross-origin"
                      allowFullScreen
                      className="video"
                      loading="lazy"
                    />
                  </div>
                )}
              </div>
            </article>
            <div className="blog-page w-100 d-flex flex-column g-col-12 g-col-lg-12 g-col-xl-4">
              <div className="recent-blog-section">
                <h3 className="text-capitalize section-title fw-medium">
                  recent post
                </h3>
                <div className="grid section-cover w-100">
                  {recentBlogs?.data?.map((item, i) => (
                    <div
                      className="g-col-12 g-col-md-6 g-col-lg-4 g-col-xl-12 recent-blog-cover"
                      key={i}
                    >
                      <RecentBlog
                        name={item.author}
                        date={formatDate(item.created_at, "DD-MM-YYYY")}
                        title={item.blog_title}
                        image={item.blog_image}
                        slug={item.blog_slug}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          
        </div>
      </Container>
    </section>
  );
};

export default FullBlogSection;
